import { XC_URL } from 'config';

export const makeQueryString = params => {
	return Object.entries(params).map(pair => pair.map(encodeURIComponent).join('=')).join('&');
};

/**
 * Extracts the first part of the URL after the hash (#) up to the first slash (/), if available, to be used as a company id
 */
export const getCompanyIdFromURL = () => {
	const { hash } = window.location;
	if (hash.length > 1) {
		return hash.split('?')[0].substr(1).split('/')[0];
	}
};

export const getLinkToEditor = (companyName) => {
	const encodedCompanyName = encodeURIComponent(companyName);
	return `${XC_URL}?company=${encodedCompanyName}`;
};

/**
 * Parse URL query string, with or without '?'. It is safe to pass document.location.search.
 *
 * For example:
 * parseQuery('?param1=value1&param2=value2')
 * returns:
 * { param1: 'value1', param2: 'value2' }
 *
 * @param queryString string with query parameters from URL
 * @returns Object with parameters as keys and their corresponding values
 */
export const parseQuery = (queryString) => {
	let params = {};
	let i = 0;
	let pair;

	// initialise to empty string if falsy
	queryString || (queryString = '');

	// remove first ? if present
	if (queryString.length && queryString.charAt(0) == '?') {
		queryString = queryString.substr(1);
	}

	// cast to string and split parameter / value pairs
	queryString = (queryString + '').split('&');

	for (; i < queryString.length; i++) {
		// split parameter from value
		pair = queryString[i].split('=', 2);
		if (pair[0]) {
			params[pair[0]] = pair[1] ? decodeURIComponent(pair[1].replace(/\+/g, ' ')) : undefined;
		}
	}
	return params;
};


// WEBPACK FOOTER //
// ./src/utils/url.js